import apiClient from './client'
import { STORAGE_KEYS } from '../utils/constants'

export const authAPI = {
  /**
   * Login merchant
   */
  login: async (email, password) => {
    const response = await apiClient.post('/login', { email, password })
    const { token, lastLogin } = response.data
    
    // Store token and merchant ID
    localStorage.setItem(STORAGE_KEYS.AUTH_TOKEN, token)
    if (response.data.merchantId) {
      localStorage.setItem(STORAGE_KEYS.MERCHANT_ID, response.data.merchantId)
    }
    
    return { token, lastLogin }
  },

  /**
   * Logout merchant
   */
  logout: () => {
    localStorage.removeItem(STORAGE_KEYS.AUTH_TOKEN)
    localStorage.removeItem(STORAGE_KEYS.MERCHANT_ID)
  },

  /**
   * Check if user is authenticated
   */
  isAuthenticated: () => {
    return !!localStorage.getItem(STORAGE_KEYS.AUTH_TOKEN)
  },

  /**
   * Get stored token
   */
  getToken: () => {
    return localStorage.getItem(STORAGE_KEYS.AUTH_TOKEN)
  },
}

